import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';

export enum Breakpoint {
  Mobile = 500,
  TabletMini = 750,
  Tablet = 992, // cambio de Desktop a mobile (dashboard)
  Desktop = 1024,
  DesktopLarge = 1280,
  DesktopExtraLarge = 1440,
}

const useMediaQuery = (breakpoint: Breakpoint) => {
  const query = `(min-width: ${breakpoint}px)`;
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);

  const isNative = Capacitor.isNativePlatform();

  if (isNative && breakpoint > Breakpoint.Tablet) {
    return false;
  }

  return matches;
};

export default useMediaQuery;
